<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.user_activity')"
      filterable
      clearable
      :multiple="multiple"
      :size="size"
      class="d-block"
    >
      <el-option
        v-for="(model, index) in models"
        :key="'models-' + index"
        :label="model.trackable_type"
        :value="model.trackable_type"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    id: {
      handler: function () {
        this.selected = this.id;
      },
      immediate: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    if (this.models && this.models.length === 0) {
      this.updateInventory();
    }
  },
  computed: {
    ...mapGetters({
      models: "userActivity/inventory",
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "userActivity/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
